export default __webpack_public_path__ + "static/media/betnearn-ico.7fca28da.svg";